/**
 * @desc 推送用户消息
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(params: API.mns.messageNoticeUser.getSendMessage.Params, options?: any) {
  return updateResponse(
    http(URL + `/messageNoticeUser/sendMessage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
